import { render, staticRenderFns } from "./SquareComissionList.vue?vue&type=template&id=50e14396&scoped=true"
import script from "./SquareComissionList.vue?vue&type=script&lang=js"
export * from "./SquareComissionList.vue?vue&type=script&lang=js"
import style0 from "./SquareComissionList.vue?vue&type=style&index=0&id=50e14396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e14396",
  null
  
)

export default component.exports